<template>
    <div>
        <template v-if="orders.length && streamUrl">
            <v-container style="display: none;">
                <v-col cols="12">
                    <v-row justify="center">
                        <v-col cols="auto" style="min-height: 240px;">
                            <v-img height="300" :src="streamUrl"/>
                        </v-col>
                    </v-row>
                </v-col>
            </v-container>
        </template>
        <!-- <template v-else>
            <v-carousel
                v-if="!orders.length"
                class="primary promo-carousel"
                cycle
                height="300"
                hide-delimiters
                show-arrows-on-hover
            >
                <v-carousel-item
                    v-for="(promotion, i) in promotions"
                    :key="i"
                    :src="promotion.imageUrl"
                    :to="{name: 'PromoDetail', params: {promotionId: promotion.id}}"
                />
            </v-carousel>
        </template> -->

        <v-container fluid>
            <template v-if="orders.length">
                <v-row dense>
                    <v-col
                        v-for="order in orders"
                        :key="`order_${order.id}`"
                        cols="12"
                    >
                        <OrderStationItem
                            :order="order"
                            :car="carState.cars[order.carId]"
                        />
                    </v-col>

                    <v-col cols="12">
                        <v-btn
                            :to="{ name: 'StationOnlineOrder'}"
                            block
                            color="primary"
                            text
                        >
                            <v-icon v-text="'$plus'" left/>
                            Новая запись
                        </v-btn>
                    </v-col>
                </v-row>
            </template>
            <template v-else>
                <v-row dense>
                    <v-col cols="12">
                        <h3>Запись на СТО</h3>
                    </v-col>
                    <v-col cols="12">
                        <p class="body-2 grey--text">
                            Рассчитайте стоимость работы и запишитесь на сервис в несколько простых шагов.
                        </p>
                    </v-col>
                    <v-col cols="12">
                        <v-btn
                            block
                            color="secondary"
                            :to="{ name: 'StationOnlineOrder' }"
                        >
                            Записаться
                        </v-btn>
                    </v-col>
                </v-row>
            </template>
        </v-container>
    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex'

    import OrderStationItem from '@/components/app/personal/order/OrderStationItem'

    export default {
        name: 'StationScreen',

        components: {
            OrderStationItem,
        },

        computed: {
            ...mapState('car', {
                carState: state => state,
            }),

            ...mapGetters({
                orders: 'order/getOrders',
                promotions: 'promotion/getPromotions',
            }),

            streamUrl() {
                for (const order of this.orders) {
                    const streamUrl = order.getStreamUrl()

                    if (streamUrl) {
                        return streamUrl
                    }
                }

                return null
            },
        },

        mounted() {
            this.$store.dispatch('order/fetch')
        },
    }
</script>
